<template>
  <div v-if="all">
    <v-row>
      <v-col cols="10" offset="1">
        <v-row>
          <v-col v-for="card in sortedAll" :key="`all-${card.id}`" cols="6">
            <v-card light class="mt-5">
              <v-card-title class="d-flex justify-space-between"
                ><span>{{ titleFor(card) }}</span
                ><v-icon class="align-self-start"
                  >mdi-airplane-takeoff</v-icon
                ></v-card-title
              >
              <v-card-subtitle class="subtitle-2"
                >Boarding pass</v-card-subtitle
              >
              <div
                v-if="emailFor(card)"
                class="px-4 pb-2 caption grey--text text--darken-1 text-truncate"
              >
                Created by {{ emailFor(card) }}
              </div>
              <v-card-text class="p1-5">
                <v-row
                  v-if="
                    card &&
                      card.doc &&
                      card.doc.selectedPlane &&
                      card.doc.selectedPlane.src
                  "
                >
                  <v-col cols="12">
                    <img
                      :src="card.doc.selectedPlane.src"
                      style="display:block; width:100%; height:auto;"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="field in fields"
                    :key="`text-${card.doc.selectedPlane.id}-${field.model}`"
                  >
                    <h3>{{ field.title }}</h3>
                    <div v-html="card.doc.ticket[field.model]"></div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import lodash from "lodash";

const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsFlySummary",
  components: {},
  data() {
    return {
      items: null,
      admins: null,
      users: null,
      all: null,
      profileCache: {},
      planesById: {},
      unsubscribePlanes: null,
      fields: [
        {
          title: "Check-in",
          model: "checkin",
          description: "How would it work and feel to check in?",
        },
        {
          title: "Ticket Price",
          model: "ticket",
          description: "How expensive or cheap would it be?",
        },
        {
          title: "Classes",
          model: "classes",
          description: "How could passengers be grouped?",
        },
        {
          title: "Passengers",
          model: "passengers",
          description: "What kind of people would be on board?",
        },
        {
          title: "Destinations",
          model: "destinations",
          description: "Where would it fly to?",
        },
        {
          title: "Entertainment and Services",
          model: "entertainment",
          description: "What kind would be available?",
        },
        {
          title: "Music",
          model: "music",
          description: "What music would they play before takeoff?",
        },
        {
          title: "Catering",
          model: "catering",
          description: "What kind of food and drink would be served?",
        },
        {
          title: "Crew",
          model: "crew",
          description: "What kind of people would they be?",
        },
        {
          title: "Ambience",
          model: "ambience",
          description: "How would it feel on board eg calm, happy?",
        },
      ],
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
    this.subscribePlanes();
  },
  beforeDestroy() {
    if (this.unsubscribePlanes) this.unsubscribePlanes();
  },
  computed: {
    sortedAll() {
      if (!this.all) return null;
      return [...this.all].sort((a, b) => {
        const at = this.titleFor(a).toLowerCase();
        const bt = this.titleFor(b).toLowerCase();
        return at.localeCompare(bt);
      });
    },
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("get exercise");
      this.doc = null;
      let ref = fb.flyExCollection.where("pid", "==", this.$route.params.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
            // if (!this.admins.some((x) => x == post.uid)) {
            //   items.push(post);
            // }
          });
          if (items) {
            this.all = items;
            items.forEach((item) => this.fetchProfile(item.uid));
            console.log("get exercise", items);
          }
        })
        .catch(function() {});
    },
    fetchProfile(uid) {
      if (!uid) return;
      if (uid in this.profileCache) return;
      this.$set(this.profileCache, uid, null);
      fb.profilesCollection
        .where("uid", "==", uid)
        .get()
        .then((snap) => {
          const doc = snap.docs[0] && snap.docs[0].data();
          this.$set(this.profileCache, uid, (doc && doc.email) || null);
        })
        .catch(() => {
          this.$set(this.profileCache, uid, null);
        });
    },
    emailFor(card) {
      if (!card || !card.uid) return null;
      return this.profileCache[card.uid] || null;
    },
    subscribePlanes() {
      if (this.unsubscribePlanes) this.unsubscribePlanes();
      this.unsubscribePlanes = fb.planesCollection.onSnapshot((snap) => {
        const map = {};
        snap.forEach((docSnap) => {
          const data = docSnap.data();
          if (data && data.id) map[data.id] = data;
        });
        this.planesById = map;
      });
    },
    titleFor(card) {
      const saved =
        (card && card.doc && card.doc.selectedPlane) || null;
      if (!saved) return "";
      const canon = saved.id ? this.planesById[saved.id] : null;
      return (canon && canon.title) || saved.title || "";
    },
  },
};
</script>
